import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewCategoryPageNew from "../../components/Category/ViewCategoryPageNew";



const ViewCategoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Category" link2="/category" title="View Category" />

        {/* AddUserLayer */}
        <ViewCategoryPageNew />


      </MasterLayout>
    </>
  );
};

export default ViewCategoryPage;
